import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Emergency Contacts and Claims' },
]
// TODO: remove this page? Move numbers to company pages
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">
				Emergency Contacts and Claims
			</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				In a true emergency, please contact 911 before contacting your insurance
				agent or company.
			</p>

			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Direct claim reporting is available for many insurance companies. See
				below. If your company is not listed, you must first report your claim
				to our office. Telephone is the quickest way to get in touch with us.
				You can call our office during normal business hours at 585-657-6101 and
				our staff will assist you in the claims process. Most companies will
				require you to provide a statement to a claims specialist.
			</p>

			<table>
				<tbody>
					<tr>
						<td>
							A Central
							<br />
							(866) 222-2242
						</td>
						<td>
							<Link
								to="/our-insurance-company-relationships/new-york-central-mutual-insurance/"
								className="text-blue-600 underline"
								prefetch="intent"
							>
								{/* <Img
                  fixed={data.nycm.childImageSharp.fixed}
                  alt="A Central"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Adirondack
							<br />
							(877) 248-0555
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/adirondack/">
								{/* <Img
                  fixed={data.adirondack.childImageSharp.fixed}
                  alt="Adirondack"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Allstate
							<br />
							(800) 347-4711
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/allstate/">
								{/* <Img
                  fixed={data.allstate.childImageSharp.fixed}
                  alt="Allstate"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Countryway
							<br />
							(888) 223-3649
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/countryway/">
								{/* <Img
                  fixed={data.countryway.childImageSharp.fixed}
                  alt="Countryway"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Encompass
							<br />
							(800) 588-7400
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/encompass/">
								{/* <Img
                  fixed={data.encompass.childImageSharp.fixed}
                  alt="Encompass"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Erie &amp; Niagara
							<br />
							(800) 234-9876
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/erie-and-niagara/">
								{/* <Img
                  fixed={data.erieniagara.childImageSharp.fixed}
                  alt="Erie and Niagara"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Farm Family
							<br />
							(800) 948-3276
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/farm-family/">
								{/* <Img
                  fixed={data.farmfamily.childImageSharp.fixed}
                  alt="Farm Family"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Main Street America Group
							<br />
							(877) 425-2467
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/the-main-street-america-group/">
								{/* <Img
                  fixed={data.mainstreetamerica.childImageSharp.fixed}
                  alt="Main Street America"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							National General
							<br />
							(800) 468-3466
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/national-general/">
								{/* <Img
                  fixed={data.nationalgeneral.childImageSharp.fixed}
                  alt="National General"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							New York Central Mutual
							<br />
							(800) 234-6926
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/new-york-central-mutual-insurance/">
								{/* <Img
                  fixed={data.nycm.childImageSharp.fixed}
                  alt="New York Central"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Preferred Mutual
							<br />
							(800) 333-7642
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/preferred-mutual/">
								{/* <Img
                  fixed={data.preferredmutual.childImageSharp.fixed}
                  alt="Preferred Mutual"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Progressive
							<br />
							(800) 776-4737
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/progressive/">
								{/* <Img
                  fixed={data.progressive.childImageSharp.fixed}
                  alt="Progressive"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Selective
							<br />
							(866) 455-9969
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/selective/">
								{/* <Img
                  fixed={data.selective.childImageSharp.fixed}
                  alt="Selective"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							The Hartford
							<br />
							(800) 327-3636
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/the-hartford/">
								{/* <Img
                  fixed={data.thehartford.childImageSharp.fixed}
                  alt="The Hartford"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Travelers
							<br />
							(800) 252-4633
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/travelers/">
								{/* <Img
                  fixed={data.travelers.childImageSharp.fixed}
                  alt="Travelers"
                /> */}
							</Link>
						</td>
					</tr>
					<tr>
						<td>
							Wayne Cooperative
							<br />
							(800) 724-1648
						</td>
						<td>
							<Link to="/our-insurance-company-relationships/wayne-cooperative/">
								{/* <Img
                  fixed={data.waynecoop.childImageSharp.fixed}
                  alt="Wayne Cooperative"
                /> */}
							</Link>
						</td>
					</tr>
				</tbody>
			</table>
		</main>
	)
}
